module.exports = __webpack_public_path__ + "static/MasterCard-White-51500d7fea4d26ade33ce1ca906f345e.svg";